import { Outlet } from "react-router-dom";

import { useMediaQuery } from "@mui/material";
import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";

import Drawer from "./Drawer";
import Header from "./Header";
import Breadcrumbs from '../../components/@extended/Breadcrumbs';


export default function DashboadLayout(){
    return (
        <Box sx={{ display: 'flex', width: '100%',flexGrow: 1  }}>
            {/* <Header/> */}
            <Drawer/>
            <Box component="main"sx={{ width: 'calc(100% - 260px)', flexGrow: 1, p: { xs: 2, sm: 3 } }} >
                {/* <Toolbar /> */}
                {/* <Breadcrumbs /> */}
                <Outlet/>
            </Box>
        </Box>

    )
}